export enum PLAYER_USER_PREFERENCE_KEY {
	VOLUME = 'vbPlayerVolume',
	SUBTITLE = 'vbPlayerSubtitle',
	AUDIO_TRACK = 'vbPlayerAudioTrack',
	PLAYBACK_RATE = 'vbPlayerPlaybackRate',
	DUAL_PLAYBACK = 'vbPlayerDualPlayback'
}
